import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { feedbackStats } from '../helpers/FeedbackStats';
import { avatarUrl, formatDate } from 'utils/Formatters';
import AccountDetails from './AccountDetails';
import AccountControls from './AccountControls';
import { isAdminDashboard, isEditable } from 'utils/authScopes';

const Account = ({ auth, account, backLink, groups, onGoBack, onResetPassword, onUpdate }) => {
  const { t } = useTranslation();
  if (isEmpty(account)) return null;
  if (get(account, 'deleted')) { onGoBack(backLink); return null; }
  const bg = { backgroundImage: avatarUrl(account) };
  const editable = isEditable(auth);
  return (
    <div className='column small-12 medium-3'>
      <div className='u-flex u-margin-bottom--base'>
        <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
        <div className='u-txt--header'>
          {account.firstName}<br/>
          {account.lastName}
        </div>
      </div>
      <div className='o-card__wrap'>
        <AccountDetails account={account} groups={groups} onUpdate={onUpdate} editable={editable} />
      </div>
      <div className='o-card__wrap'>
        <section className='column o-card cs-bg--light'>
          <p>
            <span className='u-txt--label'>{t('accountInfo.photos')}</span> {account.totalPhotos}<br/>
            <span className='u-txt--label'>{t('accountInfo.cardsPlayed')}</span> {account.totalPlays}
          </p>
          { feedbackStats(account.cards) }
        </section>
      </div>
      <div className='o-card__wrap'>
        <section className='column o-card cs-bg--light'>
          { isAdminDashboard(auth) &&
            <p>
              <span className='u-txt--label'>{t('accountInfo.partner')}</span><br/>
              {account.partner}
            </p> }
          <p>
            <span className='u-txt--label'>{t('accountInfo.applicationLocale')}</span><br/>
            {account.locale}
          </p>
          <p>
            <span className='u-txt--label'>{t('accountInfo.lastAppTouch')}</span><br/>
            {formatDate(account.lastAppTouch)}
          </p>
        </section>
      </div>
      <div className='o-card__wrap'>
        <section className='column o-card cs-bg--light'>
          <p>
            <span className='u-txt--label'>{t('accountInfo.lastAction')}</span><br/>
            {formatDate(account.lastActivity)}
          </p>
          <p>
            <span className='u-txt--label'>{t('accountInfo.platform')}</span><br/>
            {account.platform}
          </p>
          <p>
            <span className='u-txt--label'>{t('accountInfo.accountCreated')}</span><br/>
            {formatDate(account.createdAt)}
          </p>
        </section>
      </div>
      { editable && <AccountControls account={account} onResetPassword={onResetPassword} /> }
    </div>
  );
}

Account.propTypes = {
  account: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  backLink: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  onGoBack: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
}

export default Account;
